import i18n from '~/i18n';

const isIE = () => {
  var agent = navigator.userAgent.toLowerCase();
  return (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1;
};

const downloadURLS = getDownloadURLS();

function getDownloadURLS() {
  if (window.location.host.indexOf('gov-dooray.com') > -1) {
    return {
      32: {
        ko_KR: 'https://gov-dooray.com/release/files/messenger/win-x86/DoorayMessenger-x86_ko-kr_gc.msi',
        en_US: 'https://gov-dooray.com/release/files/messenger/win-x86/DoorayMessenger-x86_ko-kr_gc.msi',
        ja_JP: 'https://gov-dooray.com/release/files/messenger/win-x86/DoorayMessenger-x86_ko-kr_gc.msi',
        zh_CN: 'https://gov-dooray.com/release/files/messenger/win-x86/DoorayMessenger-x86_ko-kr_gc.msi',
      },
      64: {
        ko_KR: 'https://gov-dooray.com/release/files/messenger/win-x64/DoorayMessenger-x64_ko-kr_gc.msi',
        en_US: 'https://gov-dooray.com/release/files/messenger/win-x64/DoorayMessenger-x64_ko-kr_gc.msi',
        ja_JP: 'https://gov-dooray.com/release/files/messenger/win-x64/DoorayMessenger-x64_ko-kr_gc.msi',
        zh_CN: 'https://gov-dooray.com/release/files/messenger/win-x64/DoorayMessenger-x64_ko-kr_gc.msi',
      },
    };
  }
  return {
    32: {
      ko_KR: 'https://dooray.gslb.toastoven.net/win-x86/DoorayMessenger-x86_ko-kr.msi',
      en_US: 'https://dooray.gslb.toastoven.net/win-x86/DoorayMessenger-x86_en-us.msi',
      ja_JP: 'https://dooray.gslb.toastoven.net/win-x86/DoorayMessenger-x86_ja-jp.msi',
      zh_CN: 'https://dooray.gslb.toastoven.net/win-x86/DoorayMessenger-x86_zh-cn.msi',
    },
    64: {
      ko_KR: 'https://dooray.gslb.toastoven.net/win-x64/DoorayMessenger-x64_ko-kr.msi',
      en_US: 'https://dooray.gslb.toastoven.net/win-x64/DoorayMessenger-x64_en-us.msi',
      ja_JP: 'https://dooray.gslb.toastoven.net/win-x64/DoorayMessenger-x64_ja-jp.msi',
      zh_CN: 'https://dooray.gslb.toastoven.net/win-x64/DoorayMessenger-x64_zh-cn.msi',
    },
  };
}

if (isIE()) {
  const descriptionNode = document.createElement('div');
  const contentsStyle =
    'width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; line-height: 28px;';

  const { language } = i18n;
  const is64 = navigator.userAgent.indexOf('WOW64') !== -1 || navigator.userAgent.indexOf('Win64') !== -1;
  const urls = downloadURLS[is64 ? '64' : '32'];
  const lang =
    Object.keys(urls).find((key) => {
      return key.indexOf(language.substring(0, 2)) > -1;
    }) || 'en_US';
  const downloadURL = urls[lang];

  descriptionNode.innerHTML = `<div style="${contentsStyle}">
    <div>
      <div>
        ${i18n.t(
          'IENotSupportDescription',
          `두레이 웹 메신저는 현재 Chrome만 지원합니다. <br>Chrome에서 이용하거나, 데스크탑 메신저를 다운로드 받아주세요.`
        )}
      </div>
      <ul style="padding-left: 20px; margin-top: 30px;">
        <li><a href="https://www.google.com/chrome/" target="_blank">${i18n.t(
          'IEWorkAround.chrome',
          'Chrome에서 이용하기'
        )}</a></li>
        <li><a href="${downloadURL}" target="_blank">${i18n.t(
    'IEWorkAround.desktopApp',
    '데스크탑 메신저 다운로드'
  )}</a></li>
      </ul>
    </div>
  </div>`;
  descriptionNode.style.position = 'absolute';
  descriptionNode.style.top = '0';
  descriptionNode.style.left = '0';
  descriptionNode.style.right = '0';
  descriptionNode.style.bottom = '0';

  document.body.appendChild(descriptionNode);
}
